// добавила данный файл, так как китовский в событиях аналитики убирает нижние подчеркивания в label, а они необходимы для задачи
const MAX_TEXT_LENGTH = 300;

let storage;
export function setStorage(newStorage) {
    storage = newStorage;
}

export const getPrefix = widgetName => `SITE_Widget_${widgetName}`;

function isDesignMode() {
    return window && window.bd && window.bd.designMode;
}

export default function getSendToAnalytics(widgetName) {
    return (event, values = null) => {
        if (isDesignMode()) {
            return;
        }

        if (!storage) {
            setStorage(window.dataLayer);
        }
        if (!storage) {
            return;
        }

        let label = values;
        if (typeof label === 'number') {
            label = `${values}`;
        }
        if (label !== null && typeof label !== 'string') {
            label = convertLabelObject2String(values);
        } else {
            label = sanitizeText(label || '');
        }

        const payload = {
            event: getPrefix(widgetName),
            action: event,
            label,
        };

        storage.push(payload);
    };
}

export function sanitizeText(text) {
    return (text || '')
        .replace(/[^A-Za-zА-Яа-яЁё0-9.,_:!? -]/g, ' ')
        .replace(/\s+/, ' ')
        .substr(0, MAX_TEXT_LENGTH);
}

export function convertLabelObject2String(values) {
    return Object.keys(values)
        .filter(key => values[key] !== null && values[key] !== undefined)
        .map(key => `${key}_${values[key]}`)
        .join('__');
}
